import { Button, Modal, Text } from '@shared-ui/components'
import { useTranslation } from 'react-i18next'
import { ConfirmationModalProps } from './types'

export const ConfirmationModal = ({
    title,
    isOpen,
    contentText,
    isLoading,
    confirmActionLabel,
    onCloseModal,
    onConfirm,
    titleName,
    children,
}: ConfirmationModalProps) => {
    const { t } = useTranslation(['common', 'shared'])

    return (
        <Modal
            title={
                <Text
                    text={
                        title ||
                        t('confirmation.title', { name: titleName || '' })
                    }
                    variant="text"
                    color="title"
                    size="title"
                />
            }
            className="z-50"
            content={
                <>
                    {contentText ? (
                        <Text
                            text={
                                contentText ||
                                t('confirmation.confirmation-content')
                            }
                            variant="contained"
                            color="title"
                            className="text-md font-normal"
                        />
                    ) : null}
                    {children}
                </>
            }
            isOpen={isOpen}
            onOutsideClick={onCloseModal}
            onCloseModal={onCloseModal}
            footerComponent={
                <>
                    <Button
                        onClick={onCloseModal}
                        label={t('actions.cancel')}
                        variant="contained"
                        color="light"
                        size="base"
                    />
                    <Button
                        onClick={onConfirm}
                        label={confirmActionLabel || t('actions.delete')}
                        variant="contained"
                        color="error"
                        size="base"
                        disabled={isLoading}
                        isLoading={isLoading}
                    />
                </>
            }
        />
    )
}
